export default "<html>\n\n<head></head>\n\n<body>\n    <h1>Hier entstehen die Cookie-Richtlinien</h1>\n</body>\n\n</html>"